import { render } from "./ProductCartFavorite.vue?vue&type=template&id=2c4e8141"
import script from "./ProductCartFavorite.vue?vue&type=script&lang=js"
export * from "./ProductCartFavorite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__